// extracted by mini-css-extract-plugin
export default {"boxShadow":"CoursesItem_boxShadow__4uRHi","saleError":"CoursesItem_saleError__-dU+-","errorText":"CoursesItem_errorText__lPawF"};